// extracted by mini-css-extract-plugin
export default {"cardAd":"styles-module--cardAd---H+Ig"};